<template>
  <div>
    <b-container id="revision-statement">
      <b-row>
        <b-col>
          <span class="small">
            <!-- **Revision Statement. Page last updated on 10/27/2023. -->
          </span>
        </b-col>
      </b-row>
    </b-container>

    <b-container id="footer">
      <div class="static">
        <b-row>
          <b-col class="text-left">
            <small>
              <span style="color:#aaaaaa">
                <br>
                <p v-if="siteType === 'ABCBS'" class="footerText AnthemBCBS">&copy; 2022-2024 Anthem. Anthem Blue Cross and Blue Shield is the trade name of Anthem HealthChoice HMO, Inc. and Anthem HealthChoice Assurance, Inc. Anthem Blue Cross and Blue Shield HP is the trade name of Anthem HP, LLC. Independent licensees of the Blue Cross and Blue Shield Association. Anthem is a registered trademark of Anthem Insurance Companies, Inc.</p>
                <p v-if="siteType === 'ABC'" class="footerText AnthemBC">&copy; 2022-2024 Anthem. Anthem Blue Cross is the trade name of Anthem HealthChoice HMO, Inc. and Anthem HealthChoice Assurance, Inc. Anthem Blue Cross HP is the trade name of Anthem HP, LLC. Independent licensees of the Blue Cross and Blue Shield Association. Anthem is a registered trademark of Anthem Insurance Companies, Inc.</p>
                <p v-if="siteType === 'EBCBS'" class="footerText EmpireBCBS">&copy; 2022-2024 Anthem. Anthem Blue Cross is the trade name of Anthem HealthChoice HMO, Inc. and Anthem HealthChoice Assurance, Inc. Anthem Blue Cross HP is the trade name of Anthem HP, LLC. Independent licensees of the Blue Cross and Blue Shield Association. Anthem is a registered trademark of Anthem Insurance Companies, Inc.</p>
                <br>
              </span>
            </small>
          </b-col>
        </b-row>
      </div>
    </b-container>

  </div>
</template>

<script>
export default {
  data: function () {
    return {
      siteType: this.$parent.siteBrand
    }
  },
  method: {

  }
}
</script>
